import { useState, type KeyboardEvent } from "react";
import { useTerminalClasses } from "../theme/context";

export interface InputBarProps {
  placeholder: string;
  busy: boolean;
  onSubmit: (text: string) => void;
  onAbort: () => void;
  autoFocus?: boolean;
}

export function InputBar({
  placeholder,
  busy,
  onSubmit,
  onAbort,
  autoFocus,
}: InputBarProps) {
  const classes = useTerminalClasses();
  const [value, setValue] = useState("");

  const send = () => {
    const text = value.trim();
    if (!text || busy) return;
    onSubmit(text);
    setValue("");
  };

  const onKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    // Enter sends; Shift+Enter inserts a newline.
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className={classes.inputBar}>
      <span className="rt-prompt-sigil" aria-hidden="true">
        ›
      </span>
      <textarea
        className={classes.input}
        value={value}
        rows={1}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        autoFocus={autoFocus}
        spellCheck={false}
      />
      {busy ? (
        <button
          type="button"
          className={classes.sendButton}
          onClick={onAbort}
          aria-label="Stop"
          title="Stop"
        >
          ■
        </button>
      ) : (
        <button
          type="button"
          className={classes.sendButton}
          onClick={send}
          disabled={!value.trim()}
          aria-label="Send"
          title="Send"
        >
          ↵
        </button>
      )}
    </div>
  );
}
